<div class="inner">
  <h2 class="title">
    <img class="icon" src="assets/title-icon.svg" alt="title-icon" />
    {{ category === 'all' ? '全部' : category }}
  </h2>
  <ng-container *ngIf="!isApiLoading; else loading">
    <ng-container *ngIf="list.length && list.length !== 0; else noData">
      <div class="list">
        @for (item of list; track item){
        <div class="item" (click)="toDetail(item.catObj.catId)">
          <div class="name">{{ item.catObj.catName }}</div>
          <div class="imgBox">
            <img
              class="image"
              [src]="item.catObj.imgFile"
              [alt]="item.catObj.catName"
            />
          </div>
          <div class="tagBox">
            <span class="tag">{{ item.catObj.catSex }}</span>
            <span class="tag">{{
              item.catObj.catTnr === 0 ? '無結紮' : '有結紮'
            }}</span>
            <span class="tag">{{
              item.catObj.catChip === 0 ? '無晶片' : '有晶片'
            }}</span>
          </div>
        </div>
        }
      </div>
    </ng-container>
  </ng-container>
  <app-pagination
    *ngIf="list.length && list.length !== 0"
    class="pagination"
    [pageSize]="pageSize"
    [dataSize]="dataSize"
    [maxPage]="5"
    (changePageEvent)="changePage($event)"
  ></app-pagination>
</div>
<ng-template #loading>
  <app-loading [isLoading]="isApiLoading"></app-loading>
</ng-template>
<ng-template #noData>
  <app-no-data></app-no-data>
</ng-template>
